export const capitalizarPrimeraLetra = (str) => {
  if (!str) return "";

  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatearFechaEspanol = (fechaString) => {
  if (!fechaString) return "";

  const meses = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];

  const [año, mes, dia] = fechaString.split("/");
  const mesIndex = parseInt(mes) - 1;

  if (mesIndex < 0 || mesIndex > 11) return fechaString;

  return `${dia} de ${meses[mesIndex]} del ${año}`;
};

export const esHoy = (fechaString) => {
  if (!fechaString) return false;

  const hoy = new Date();
  const dia = String(hoy.getDate()).padStart(2, "0");
  const mes = String(hoy.getMonth() + 1).padStart(2, "0");
  const año = hoy.getFullYear();

  const fechaHoy = `${año}/${mes}/${dia}`;
  return fechaString === fechaHoy;
};

export const formatearHora = (horaString) => {
  if (!horaString) return "";

  // Si ya está en formato HH:MM, devolverlo tal como está
  if (horaString.includes(":")) {
    return horaString;
  }

  // Si está en otro formato, intentar parsearlo
  try {
    const fecha = new Date(horaString);
    return fecha.toLocaleTimeString("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return horaString;
  }
};
